function runSwiperSlider() {
  if (typeof Swiper === "undefined") {
    console.warn("Swiper is not ready yet. Retrying...");
    setTimeout(runSwiperSlider, 200);
    return;
  }

  const container = document.querySelector('.swiper-container');
  if (!container) {
    console.warn("Swiper container not found. Retrying...");
    setTimeout(runSwiperSlider, 200);
    return;
  }

  if (container.classList.contains('swiper-initialized')) return;

  new Swiper(container, {
    loop: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    speed: 10000,
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 0,
    //observer: true,
    //observeParents: true,
    breakpoints: {
      1200: {
        slidesPerView: 2.3,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 0,
      }
    }
  });

  container.classList.add('swiper-initialized');
}

window.addEventListener("load", runSwiperSlider);
document.addEventListener("shopify:section:load", runSwiperSlider);
